import { Model } from '@/models/Model';
import { TextboxQuestion } from '@/models/question-models/question-textbox';
import { HeaderQuestion } from '@/models/question-models/question-header';
import { AlertQuestion } from '@/models/question-models/question-alert';
import { DateQuestion } from '@/models/question-models/question-date';
import { YearQuestion } from '@/models/question-models/question-year';
import { RadioQuestion } from '@/models/question-models/question-radio';
import { TextareaQuestion } from '@/models/question-models/question-textarea';
import { CheckboxQuestion } from '@/models/question-models/question-checkbox';

export class Question extends Model {
  protected $name = 'Question';

  protected $endpoint = '/hin/questions';

  protected $fillable: string[] = [];

  public answer?: any;

  public form_type?: string;

  public is_editable?: string;

  public is_required?: string;

  public key?: string;

  public options?: Option[];

  public question_option_id?: string;

  public section?: number;

  public sort_order?: string;

  public placeholder?: string;

  public label?: string;

  public tab?: number;

  public type_raw?: string;

  public uuid?: string;

  public value?: string;

  public visible?: boolean;

  public is_formattable?: boolean;

  public disabled?: boolean;

  public is_disabled?: boolean | string;

  protected parseQuestion(attributes: any) {
    switch (attributes.type) {
      case 'textbox':
        return new TextboxQuestion(attributes);
      case 'header':
        return new HeaderQuestion(attributes);
      case 'alert':
        return new AlertQuestion(attributes);
      case 'date':
        return new DateQuestion(attributes);
      case 'year':
        return new YearQuestion(attributes);
      case 'radio':
        return new RadioQuestion(attributes);
      case 'textarea':
        return new TextareaQuestion(attributes);
      case 'checkbox':
        return new CheckboxQuestion(attributes);
      default:
        break;
    }
  }

  public parseQuestions(questions: any[]): Question[] {
    const allQuestions: any[] = [];
    questions.forEach((question: any) => {
      if (! question) { return; }
      allQuestions.push(this.parseQuestion(question));
      question.options.forEach((option: any) => {
        option.questions = this.parseQuestions(option.questions);
      });
    });
    return allQuestions;
  }
}

export interface Option {
  created_at?: string;
  key?: string;
  label?: string;
  questions?: Question[]
  sort_order?: string;
  type?: string;
  updated_at?: string;
  uuid?: string;
  value?: string;
}
